import { computed, when } from 'mobx';
import { CXContainerableBlock } from '~/components/ClientExperience/OneFlow/models/cx-containerable-block.model';
import {
    IContractBlockResponse,
    IContainerableBlockResponse
} from '~/types/server.types';
import { ContainerableBlock } from '~/models/blocks/containerable-block.model';
import type { CXRootStore } from '~/components/ClientExperience/stores/cx-root.store';
import { IChildLayout } from '~/types/model.types';
import { ContractBlock } from '~/models/blocks/contract-block.model';
import type { CXSignatureBlock } from '~/components/ClientExperience/OneFlow/models/cx-signature-block.model';
import type { CXSignaturesBlock } from '~/components/ClientExperience/OneFlow/models/cx-signatures-block.model';
import { deleteValueFromStorage } from '~/common/hooks/useStorage';
import type { CXContractHTMLBlock } from '~/components/ClientExperience/OneFlow/models/cx-contract-html-block.model';
import type { FlowRevision } from '~/models/flow-revision.model';

export class CXContractBlock extends CXContainerableBlock {
    type: 'contract_block';

    constructor(
        block: IContractBlockResponse | ContractBlock,
        flowRevision: FlowRevision<CXRootStore>,
        rootStore: CXRootStore
    ) {
        super(
            block as IContainerableBlockResponse | ContainerableBlock,
            flowRevision,
            rootStore
        );
        this.type = block.type;

        if (block instanceof ContractBlock) {
            this.children = (<ContractBlock>block).children;
        } else {
            this.children = block.children as IChildLayout[];
        }

        this.children = this.children || [];

        // Delete local storage data
        when(
            () => this.isContractSigned,
            () =>
                deleteValueFromStorage({
                    key: `${this.flow_id}_cxStorage`,
                    path: `${this.page_id}.contract`
                })
        );
    }

    @computed
    get isActionBlockForPrint() {
        return true;
    }

    get displayName() {
        return 'contract';
    }

    @computed
    get contractHTMLBlock() {
        return this.childBlocks.find(
            block => block.type === 'contract_html_block'
        ) as CXContractHTMLBlock;
    }

    @computed
    get signaturesBlock() {
        return this.childBlocks.find(
            block => block.type === 'signatures_block'
        ) as CXSignaturesBlock | undefined;
    }

    @computed
    get isPendingClientCompletion() {
        return !!this.signaturesBlock.unsignedRequiredCurrUserSignature;
    }

    @computed
    get isContractSigned() {
        return (this.signaturesBlock as CXSignaturesBlock).childBlocks.some(
            child => {
                return (
                    (child as CXSignatureBlock).signature.signee_type ===
                        'client' && (child as CXSignatureBlock).isSigned
                );
            }
        );
    }
}
